"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Image = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 41 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "40",
  height: "40"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H39.9999V40H0V0Z",
  fill: "white"
})), /*#__PURE__*/_react.default.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.6282 0H3.37179C1.50905 0 0 1.50989 0 3.37179V36.6282C0 38.4901 1.50905 40 3.37179 40H36.6282C38.4901 40 40 38.4901 40 36.6282V3.37179C40 1.50989 38.4901 0 36.6282 0ZM36.628 3.36842L36.6314 3.37179L36.628 36.6316L3.36825 36.6282L3.37161 3.36842H36.628Z",
  fill: "black"
})), /*#__PURE__*/_react.default.createElement("path", {
  opacity: "0.397938",
  d: "M2.94727 36.6316L13.0525 26.5263L19.7894 32L29.4736 19.7895L37.4736 26.9474",
  stroke: "black",
  strokeWidth: "4",
  strokeLinecap: "square",
  strokeLinejoin: "round"
}), /*#__PURE__*/_react.default.createElement("path", {
  opacity: "0.397938",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3685 8.42106C8.57866 8.42106 6.31592 10.6838 6.31592 13.4737C6.31592 16.2636 8.57866 18.5263 11.3685 18.5263C14.1584 18.5263 16.4212 16.2636 16.4212 13.4737C16.4212 10.6838 14.1584 8.42106 11.3685 8.42106ZM11.3683 10.9474C12.7611 10.9474 13.8946 12.0808 13.8946 13.4737C13.8946 14.8665 12.7611 16 11.3683 16C9.97544 16 8.84196 14.8665 8.84196 13.4737C8.84196 12.0808 9.97544 10.9474 11.3683 10.9474Z",
  fill: "black"
}));

var _default = Image;
exports.default = _default;